// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1tr5N","visuallyhidden":"_3PXlu","hide-text":"_2zIOB","center":"_1lP7v","noprint":"_3m5bB","root":"_3d744","contentContainer":"_2ExW9","noA":"MoZLw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/theme/article/feature.scss
 ** module id = 209
 ** module chunks = 2
 **/